module.exports = __webpack_public_path__ + "img/cap.f5907370.png";